import { useEffect, useState } from 'react';

interface UseLocalStorageReturn<T> {
    data: T;
    storeData: (updateValue: T) => void;
}

const useLocalStorage = <T,>(key: string, initialValue: T): UseLocalStorageReturn<T> => {
    const [data, setData] = useState<T>(initialValue);
    useEffect(() => {
        const getData: string | null = window.localStorage.getItem(key);

        if (getData) {
            setData(JSON.parse(getData) as T);
        }
    }, [key]);

    const storeData = (updateValue: T): void => {
        setData(updateValue);
        window.localStorage.setItem(key, JSON.stringify(updateValue));
    };

    return {
        data,
        storeData,
    };
};

export default useLocalStorage;
